export default "__VITE_ASSET__G5O4n2Fe__"